import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings
import { providersCasino } from 'config/config'; // Importing casino providers configuration
import { gamesCasino } from 'config/config'; // Importing casino games configuration

/**
 * Class representing the FilterPlayerPrizesLoyaltyView.
 * @extends JetView
 */
export default class FilterPlayerPrizesLoyaltyView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for IdBonus
                            minWidth: 200,
                            name: 'IdBonus',
                            type: 'number',
                            label: _('Id Regalo'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Id Regalo'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for Datepicker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker for Date
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for DateM
                            name: 'DateM',
                            id: 'DateM',
                            css: 'reportrange2',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificó'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker for DateM2
                            name: 'DateM2',
                            id: 'DateM2',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificó'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for TypeAward selection
                            name: 'TypeAward',
                            label: _('Tipo'), // Localized label
                            labelPosition: 'top',
                            value: '1', // Default value
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: [
                                { id: '1', value: _('Online') }, // Localized option
                                { id: '0', value: _('Físico') }, // Localized option
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for ResultTypeId
                            name: 'ResultTypeId',
                            label: _('Estado'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: '4', // Default value
                            options: [
                                { id: '4', value: _('Comprado') }, // Localized option
                                { id: '5', value: _('Entregado') }, // Localized option
                            ],
                        },
                        { gravity: 2, id: 'grav', minWidth: 200 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: 140,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'),
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('playerPrizesLoyaltyReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to submit
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('playerPrizesLoyaltyReport:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filter sections
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the filter popup
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section in the scroll view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        $$('DateM').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
                $$('DateM2').hide(); // Hide DateM2 if typeDate is not 2
                $$('DateM').show(); // Show DateM
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                    $$('DateM2').show(); // Show DateM2
                    $$('DateM').hide(); // Hide DateM if typeDate is 2
                }
            }
        });
    }
}

// FILE DOCUMENTED
